import { inject, Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject, Subscription, timer } from 'rxjs';
import { AuthService } from './auth.service';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root'  // En lugar de providers en el componente
})
export class IdleTimeoutService implements OnDestroy {
    private _count = 0;
    //private _serviceId: string = 'idleTimeoutSvc-' + Math.floor(Math.random() * 10000);
    private _serviceId = `idleTimeoutSvc-${uuidv4()}`;
    private timerSubscription?: Subscription;
    private timer!: Observable<number>;

    private resetOnTrigger = false;
    private lastTime!: number;

    private dateTimer!: Observable<number>;
    private dateTimerSubscription?: Subscription;
    private dateTimerInterval: number = 1000 * 60 * 55; // Temporizador para el logout
    private dateTimerTotal: number = 1000 * 60 * 60;
    private dateTimerLogout: number = 1000 * 60 * 5;
    private dateTimerTolerance: number = 1000 * 10;
    public timeoutExpired: Subject<number> = new Subject<number>();


    private authService: AuthService = inject(AuthService);
    constructor() {
        this.startTimer();
        this.startDateCompare();
    }

    ngOnDestroy(): void {
        this.stopTimer();
        this.dateTimerSubscription?.unsubscribe();
        this.timeoutExpired.complete();
    }

    private setSubscription() {
        this.timer = timer(this.dateTimerInterval);
        this.timerSubscription = this.timer.subscribe(() => {
            this.timerComplete();
        });
    }

    private startDateCompare() {
        this.lastTime = (new Date()).getTime();
        this.dateTimer = timer(this.dateTimerInterval);
        this.dateTimerSubscription = this.dateTimer.subscribe(() => {
            const currentTime: number = (new Date()).getTime();
            if (currentTime > (this.lastTime + this.dateTimerInterval + this.dateTimerTolerance)) {
                // Sesión reactivada después de suspensión
            }
            this.dateTimerSubscription?.unsubscribe();
            this.startDateCompare();
        });
    }

    private startDateCompareLogout() {
        this.lastTime = (new Date()).getTime();
        this.dateTimer = timer(this.dateTimerTotal - this.dateTimerInterval - this.dateTimerLogout);
        this.dateTimerSubscription = this.dateTimer.subscribe(() => {
            this.dateTimerSubscription?.unsubscribe();
            this.stopTimer();
            this.authService.logout();
        });
    }

    public startLogout(c: number) {
        this.dateTimerLogout = 1000 * 10 * 1;
        if (c === 0) {
            this.dateTimerSubscription?.unsubscribe();
            this.stopTimer();
            this.authService.logout();
        } else if (c * 1000 < (this.dateTimerInterval + this.dateTimerLogout)) {
            this.dateTimerLogout = (c * 1000) - this.dateTimerInterval;
            this.dateTimerSubscription?.unsubscribe();
            this.startTimer();
            this.startDateCompareLogout();
        } else {
            this.dateTimerSubscription?.unsubscribe();
            this.stopTimer();
            this.authService.logout();
        }
    }

    public startTimer() {
        if (this.timerSubscription) {
            this.stopTimer();
        }
        this.setSubscription();
    }

    public stopTimer() {
        this.timerSubscription?.unsubscribe();
    }

    public resetTimer() {
        this.startTimer();
    }

    private timerComplete() {
        this.timeoutExpired.next(++this._count);

        if (this.resetOnTrigger) {
            this.startTimer();
        }
    }
}
